import React from "react";
import { Link } from "react-router-dom";
import { ArrowUp, Github, Linkedin, Mail } from "lucide-react";
import { Lockup } from "./brand/Mark";
import { ME } from "../data/cv";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-hair pt-10 pb-4">
      <div className="flex flex-col gap-8 desk:flex-row desk:items-start desk:justify-between">
        <div>
          <Lockup size={26} />
          <p className="mt-4 max-w-[34ch] text-[13.5px]">
            {ME.role} {ME.second}. Uit {ME.place.split(",")[0]}.
          </p>

          <div className="mt-5 flex gap-1">
            {[
              { href: `mailto:${ME.email}`, icon: Mail, label: "Mail" },
              { href: ME.github, icon: Github, label: "GitHub" },
              { href: ME.linkedin, icon: Linkedin, label: "LinkedIn" },
            ].map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer noopener"
                aria-label={label}
                className="tap grid size-11 place-items-center rounded-full border border-line text-muted transition-colors hover:text-fg"
              >
                <Icon aria-hidden className="size-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="Voettekst" className="flex flex-col gap-2.5">
          <span className="kicker">Pagina's</span>
          {[
            { to: "/", label: "Start" },
            { to: "/projects", label: "Werk" },
            { to: "/contact", label: "Contact" },
            { to: "/privacy", label: "Privacy" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="tap w-fit text-[14px] font-semibold transition-colors hover:text-accent-text"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="tap inline-flex w-fit items-center gap-2 rounded-full border border-line px-5 py-3 text-[13px] font-semibold transition-colors hover:text-accent-text"
        >
          <ArrowUp aria-hidden className="size-4" strokeWidth={2} />
          Naar boven
        </button>
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-hair pt-5">
        <span className="kicker">© {new Date().getFullYear()} {ME.name}</span>
        <span className="kicker text-accent-text">Gebouwd om te blijven werken</span>
      </div>
    </footer>
  );
}
